var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('input',{staticClass:"color-picker",attrs:{"type":"color"},domProps:{"value":_vm.defaultColor},on:{"input":function($event){return _vm.$emit('colorChanged', $event.target.value)}}}),_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }